// extracted by css-extract-rspack-plugin
export default {"leftPanel":"BnSyB","rightPanel":"e_eJM","panelContent":"gPDBE","reactFlow":"yXhU2","controls":"p7vhi"};